import { createActions } from "redux-actions";

export enum AiAssistActionTypes {
    SET_INVERSE_DATA = 'SET_INVERSE_DATA',
    SET_INVERSE_DATA_SUCCESS = 'SET_INVERSE_DATA_SUCCESS',
    CLEAR_INVERSE_DATA = 'CLEAR_INVERSE_DATA'
}

export const {
    setInverseData,
    setInverseDataSuccess,
    clearInverseData
} = createActions({
        [AiAssistActionTypes.SET_INVERSE_DATA]: res => res,
        [AiAssistActionTypes.SET_INVERSE_DATA_SUCCESS]: res => res,
        [AiAssistActionTypes.CLEAR_INVERSE_DATA]: res => res
});
